import { IEvent } from "@quest/adapter-interface";
import { Container, ingenuity, SpineBase } from "@quest/base-core";
import { BackgroundController, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { gameConstants } from "../Constants/gameConstants";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class BackgroundControllerGame extends BackgroundController {
  protected collectionBgContainer: Container;
  protected collectionBg: SpineBase;
  protected collectionPortBg: SpineBase;

  protected initializeElements() {
    super.initializeElements();
    this.basegameIldeSpine = this.view.getSpineById("base_game_idle");
    this.collectionBgContainer = this.view.getContainerByID("collectionBgContainer");
  }
  /**
   * to initialize game specific spines
   */
  protected initializeSpine(e: IEvent): void {
    if (e.data.name === SlotConstantsBehavior.FREEGAME_IDLE_SPINE_ID) {
      this.freegameBgSpine = this.view.getSpineById("freegame_idle");
    }
    if (e.data.name === SlotConstantsBehavior.FREEGAME_IDLE_PORTRAIT_SPINE_ID) {
      if (!ingenuity.deviceEnv.isDesktop) {
        this.freegameBgPortraitrSpine = this.view.getSpineById("freegame_idle_portrait");
      }
    }
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
      this.freegameBgPortraitrSpine && (this.freegameBgPortraitrSpine.visible = true);
      this.freegameBgSpine && (this.freegameBgSpine.visible = false);
    }else{
      this.freegameBgSpine && (this.freegameBgSpine.visible = true);
      this.freegameBgPortraitrSpine && (this.freegameBgPortraitrSpine.visible = false);
    }
    if (e.data.name === "collection_screen" ) {
      this.collectionBg = this.view.getSpineById("collection_screen");
      if (!ingenuity.deviceEnv.isDesktop) {
        this.collectionPortBg = this.view.getSpineById("collection_screen_portrait");
      }
    }
  }
  /**
   * overrided to handle game specific backgrounds
   */
  protected changeBackground(evt: IEvent): void {
    this.hideAllBg();
    switch (evt.data) {
      case gameConstants.COLLECTION_BG:
        this.showCollectionBg();
        break;
      case SlotConstantsBehavior.FULLSCREEN_BIGWIN_BLUR_BG:
        this.showBaseGameBg();
        break;
      default:
        super.changeBackground(evt);

    }
  }
  /**
   * to update portrait animation ,as it comes with desktop package
   */
  protected playBasegameIdlePortraitSpine(): void {
    this.basegameIldePortraitSpine && this.basegameIldePortraitSpine.setPause(false);
    this.basegameIldePortraitSpine?.playAnim("desktop_idle_portrait", true);
  }
  /**
  * to update portrait animation ,as it comes with desktop package
  */
  protected playFreegameIdlePortraitSpine(): void {
    this.freegameBgPortraitrSpine && this.freegameBgPortraitrSpine.setPause(false);
    this.freegameBgPortraitrSpine?.playAnim("freegame_portrait_idle", true);
  }
  /**
   * function is resposible for  BG of collection panel
   */
  protected showCollectionBg(): void {
    !ingenuity.deviceEnv.isDesktop && this.showCollectionPortBg();
    this.collectionBgContainer.visible = true;
    this.collectionBg && this.collectionBg.setPause(false);
    this.collectionBg?.onComplete.dispose();
    setTimeout(() => {
      this.collectionBg.playAnim("collection_popup_intro", false);
      this.collectionBg.onComplete.addOnce(() => {
        this.collectionBg.playAnim("collection_bg_idle", true);
      }, this);
    }, 0)
  }
  /**
   * function is resposible for portrait BG of collection panel
   */
  protected showCollectionPortBg(): void {
    this.collectionBgContainer.visible = true;
    this.collectionPortBg && this.collectionPortBg.setPause(false);
    this.collectionPortBg?.onComplete.dispose();
    setTimeout(() => {
      this.collectionPortBg.playAnim("collection_popup_intro_portrait", false);
      this.collectionPortBg.onComplete.addOnce(() => {
        this.collectionPortBg.playAnim("collection_bg_idle_portrait", true);
      }, this);
    }, 0)
  }
  /**
   * overrided to hide game specific Backgrounds
   */
  protected hideAllBg(): void {
    super.hideAllBg();
    this.collectionBgContainer.visible = false;
    this.collectionBg && this.collectionBg.setPause(true);
    this.collectionPortBg && this.collectionPortBg.setPause(true);
  }
}
